import { render, staticRenderFns } from "./EducationalGroupTransfers.vue?vue&type=template&id=d1747414&"
import script from "./EducationalGroupTransfers.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports